import React, { Component, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Col, Container, Card, CardBody, Button, Row } from 'reactstrap';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/core/styles";
import FormHelperText from '@material-ui/core/FormHelperText';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import ModalMessage from '../../../../shared/components/Modal';
import Modal from '@material-ui/core/Modal';
import MapAddressSearch from '../../../../shared/components/MapAddressSearch';
import history from '../../../../history';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
    date: {
        margin: 10,
        width: 215
    },
});

class UpdatePatient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeOfDocument: '',
            documentNumber: '',
            id_patient: '',
            id_history: '',
            names: '',
            firstLastName: '',
            secondLastName: '',
            gender: '',
            address: '',
            email: '',
            cellphone: '',
            telephone1: '',
            telephone2: '',
            bloodType: '',
            fec_ingreso: new Date(),
            birthday: new Date(),
            civilStatus: '',
            race: '',
            races: [],
            ethnicity: '',
            ethnicities: [],
            countries: [],
            ocupation: '',
            country: '',
            department: '',
            city: '',
            id_city: '',
            regime: '',
            regimes: [],
            exist: false,
            update: false,
            errors: {},
            error: false,
            openAlert: false,
            modalAlert: { message: '', color: '', title: '' },
            openMap: false,
            departments: [],
            cities: [],
            zone: null,
            vitalState: '',
            isPropsFromLocation: false
        }
    }

    handlerDocumentNumber = (number) => {
        this.setState({ documentNumber: number }, () => {
            //this.loadDataPatient();
        });
    }

    handlerTypeOfDocument = (type) => {
        this.setState({ typeOfDocument: type });
    }

    handlerNames = (names) => {
        this.setState({ names: names });
    }

    handlerFirstLastName = (name) => {
        this.setState({ firstLastName: name });
    }


    handlerSecondLastName = (name) => {
        this.setState({ secondLastName: name });
    }

    handlerGender = (gender) => {
        this.setState({ gender: gender });
    }

    handlerBirthDate = (birthday) => {
        this.setState({ birthday: birthday });
    };

    handlerCivilStatus = (status) => {
        this.setState({ civilStatus: status });
    }

    handlerRace = (race) => {
        this.setState({ race: race });
    }

    handlerEthnicity = (ethnicity) => {
        this.setState({ ethnicity: ethnicity })
    }

    handlerCountry = (country) => {
        this.setState({ country: country });
    }

    handlerDepartment = (department) => {
        this.setState({ department: department, city: [] }, () => {
            this.loadCities(department).then((cities) => {
                //console.log(cities);
                this.setState({ cities: cities })
            });
        });
    }

    handleCity = (e) => {
        //console.log(e);
        this.setState({ city: e });
    }

    handlerCity = (city) => {
        this.setState({ id_city: city }, () => {
            let citySelected = this.state.cities.find((ciudad) => ciudad.ciucod === city);
            this.handleCity(citySelected.ciunom);
        });
    }

    handlerAddress = (address) => {
        this.setState({ address: address });
    }

    handlerTelephone1 = (telephone) => {
        this.setState({ telephone1: telephone })
    };

    handlerTelephone2 = (telephone) => {
        this.setState({ telephone2: telephone })
    };

    handlerCellphone = (cellphone) => {
        this.setState({ cellphone: cellphone })
    };

    handlerEmail = (email) => {
        this.setState({ email: email });
    };

    handlerRegime = (regime) => {
        this.setState({ regime: regime })
    };

    handlerBloodType = (bloodType) => {
        this.setState({ bloodType: bloodType });
    };

    handlerVitalState = (vitalState) => {
        this.setState({ vitalState: vitalState });
    };

    handlerZone = (zone) => {
        this.setState({ zone: zone });
    };

    componentDidMount = () => {
        var id_departamento = null;
        if (this.props.hasOwnProperty('location')) {
            this.setState({ isPropsFromLocation: true });
            if (this.props.location?.hasOwnProperty('state')) {
                id_departamento = this.props.location.state.patient.contenido[0].direccion.id_departamento;
            }
        } else {
            id_departamento = this.props.patient.direccion.id_departamento;
        }
        this.loadPatient(this.props);
        console.log(this.props);
        this.LoadRaces();
        this.loadCountries();
        this.LoadEthnicities();
        this.loadRegimes();
        this.loadDepartment().then((departments) => {
            this.setState({ departments: departments }, () => {
                this.loadCities(id_departamento).then((cities) => {
                    this.setState({ cities: cities });
                    //console.log(departments);
                    /*this.loadDataProfile().then((profile)=> {
                        this.setState({ department: { value: this.state.departments.filter((department)=>{ return department.id ==  profile[0].direccion.id_dpto})[0].depcod, label: this.state.departments.filter((department)=>{ return department.id ==  profile[0].direccion.id_dpto})[0].depnom, id: this.state.departments.filter((department)=>{ return department.id ==  profile[0].direccion.id_dpto})[0].id } }, ()=> {
                            this.loadCities(this.state.department.value).then((cities) => {
                                this.setState({cities: cities}, () =>{
    
                                })
                            })
                        })
                    })*/
                })
            });
            //this.loadCities();

        })
    }

    loadPatient = (props) => {

        console.log("LOADPATIENT", props);
        if (props.hasOwnProperty('location')) {
            if (props.location?.hasOwnProperty('state')) {
                this.setState({
                    documentNumber: props.location.state.patient.contenido[0].num_documento,
                    id_patient: props.location.state.patient.contenido[0].id_paciente,
                    names: props.location.state.patient.contenido[0].nombres,
                    firstLastName: props.location.state.patient.contenido[0].apellido1,
                    secondLastName: props.location.state.patient.contenido[0].apellido2,
                    gender: props.location.state.patient.contenido[0].sexo,
                    typeOfDocument: props.location.state.patient.contenido[0].tip_documento,
                    address: props.location.state.patient.contenido[0].direccion.direccion,
                    department: props.location.state.patient.contenido[0].direccion.id_departamento,
                    city: props.location.state.patient.contenido[0].direccion.ciudad,
                    id_city: props.location.state.patient.contenido[0].direccion.id_ciudad,
                    country: props.location.state.patient.contenido[0].direccion.id_pais,
                    email: props.location.state.patient.contenido[0].correo,
                    cellphone: props.location.state.patient.contenido[0].celular,
                    telephone1: props.location.state.patient.contenido[0].telefono1,
                    telephone2: props.location.state.patient.contenido[0].telefono2,
                    civilStatus: props.location.state.patient.contenido[0].e_civil,
                    birthday: props.location.state.patient.contenido[0].fec_nacimiento,
                    bloodType: props.location.state.patient.contenido[0].tipo_sangre,
                    regime: props.location.state.patient.contenido[0].id_regimen,
                    ethnicity: props.location.state.patient.contenido[0].id_etnia,
                    race: props.location.state.patient.contenido[0].id_raza,
                    fec_ingreso: props.location.state.patient.contenido[0].fec_ingreso,
                    id_history: props.location.state.patient.contenido[0].id_historia,
                    zone: props.location.state.patient.contenido[0].zona,
                    ocupation: props.location.state.patient.contenido[0].ocupacion,
                    vitalState: props.location.state.patient.contenido[0].estado_vital
                });
            }
        } else {
            this.setState({
                documentNumber: props.patient?.num_documento,
                id_patient: props.patient?.id_paciente,
                names: props.patient?.nombres,
                firstLastName: props.patient?.apellido1,
                secondLastName: props.patient?.apellido2,
                gender: props.patient?.sexo,
                typeOfDocument: props.patient?.tip_documento,
                address: props.patient?.direccion.direccion,
                department: props.patient?.direccion.id_departamento,
                city: props.patient?.direccion.ciudad,
                id_city: props.patient?.direccion.id_ciudad,
                country: props.patient?.direccion.id_pais,
                email: props.patient?.correo,
                cellphone: props.patient?.celular,
                telephone1: props.patient?.telefono1,
                telephone2: props.patient?.telefono2,
                civilStatus: props.patient?.e_civil,
                birthday: props.patient?.fec_nacimiento,
                bloodType: props.patient?.tipo_sangre,
                regime: props.patient?.id_regimen,
                ethnicity: props.patient?.id_etnia,
                race: props.patient?.id_raza,
                fec_ingreso: props.patient?.fec_ingreso,
                id_history: props.patient?.id_historia,
                zone: props.patient?.zona,
                ocupation: props.patient?.ocupacion,
                vitalState: props.patient?.estado_vital
            });
        }
    }



    loadClientAndActivity = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'serter/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                //console.log(data);
                this.setState({ serter: data });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    loadPlans = async (tercero) => {
        var data = { id: tercero.id_tercero };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.existe) {
                    this.setState({ plans: data.contenido, activities: [], activity: {} });
                } else {
                    this.setState({ plans: [], plan: {}, activities: [], activity: {} });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    loadActivities = async (tercero, plan) => {
        var data = { id_tercero: tercero.id_tercero, id_plan: plan.id_plan };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'serter/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.existe) {
                    this.setState({ activities: data.contenido[0].servicios.servicios });
                } else {
                    this.setState({ activities: [], activity: {} });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    LoadEthnicities = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'etnia/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                //console.log(data); 
                this.setState({ ethnicities: data })
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    LoadRaces = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'raza/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                //console.log(data);
                this.setState({ races: data });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    loadRegimes = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'regimen/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                //console.log(data);
                this.setState({ regimes: data });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    loadCountries = async () => {

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'paises/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                this.setState({ countries: data });
            })
            .catch((error) => {
                console.error('Error:', error);
            });

    }

    loadDepartment = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'departamentos/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })

    }

    loadCities = (depcod) => {
        var data = { id_dpto: depcod };
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'ciudades/listar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })
    }

    loadcity = (id) => {
        let data = { id_ciudad: id };
        //console.log(data);
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'ciudades/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })
    }

    validateData = () => {
        var errors = this.state.errors;
        var error = false;

        if (this.state.typeOfDocument === "") {
            errors.typeOfDocument = "Seleccione un tipo de documento";
            error = true;
        } else {
            errors.typeOfDocument = "";
        }

        if (this.state.documentNumber === "") {
            errors.documentNumber = "Ingrese un número de documento";
            error = true;
        } else {
            errors.documentNumber = "";
        }

        if (this.state.names === "") {
            errors.names = "Ingrese al menos un nombre";
            error = true;
        } else {
            errors.names = "";
        }

        if (this.state.firstLastName === "") {
            errors.firstLastName = "Ingrese apellido";
            error = true;
        } else {
            errors.firstLastName = "";
        }

        /* if (this.state.secondLastName === "") {
            errors.secondLastName = "Ingrese apellido";
            error = true;
        } else {
            errors.secondLastName = "";
        } */

        if (this.state.gender === "") {
            errors.gender = "Seleccione un genero";
            error = true;
        } else {
            errors.gender = "";
        }

        if (moment(this.state.birthday).format("YYYY/MM/DD") === moment(new Date()).format("YYYY/MM/DD")) {
            errors.birthday = "Seleccione una fecha";
            error = true;
        } else {
            errors.birthday = "";
        }

        if (this.state.country === "") {
            errors.country = "Seleccione un país";
            error = true;
        } else {
            errors.country = "";
        }

        if (this.state.department === "") {
            errors.department = "Seleccione un departamento";
            error = true;
        } else {
            errors.department = "";
        }

        if (this.state.city === "") {
            errors.city = "Seleccione una ciudad";
            error = true;
        } else {
            errors.department = "";
        }

        if (this.state.address === "") {
            errors.address = "Ingrese una dirección";
            error = true;
        } else if (!this.state.address.match(/^[a-zA-Z0-9\s]+$/)) {
            errors.address = "Ingrese una dirección sin caracteres especiales";
            error = true;
        } else {
            errors.address = "";
        }

        /* if (this.state.telephone1 === "") {
            errors.telephone1 = "Ingrese una telefono";
            error = true;
        } else {
            errors.telephone1 = "";
        } */

        if (this.state.cellphone === "") {
            errors.cellphone = "Ingrese un celular";
            error = true;
        } else {
            errors.cellphone = "";
        }


        if (this.state.email === "") {
            errors.email = "Ingrese un email";
            error = true;
        } else {
            errors.email = "";
        }

        if (this.state.civilStatus === "") {
            errors.civilStatus = "Seleccione un estado civil";
            error = true;
        } else {
            errors.civilStatus = "";
        }

        /* if (this.state.race === "") {
            errors.race = "Seleccione un raza";
            error = true;
        } else {
            errors.race = "";
        }

        if (this.state.ethnicity === "") {
            errors.ethnicity = "Seleccione etnia";
            error = true;
        } else {
            errors.ethnicity = "";
        } */

        if (this.state.bloodType === "") {
            errors.bloodType = "Seleccione etnia";
            error = true;
        } else {
            errors.bloodType = "";
        }

        if (this.state.vitalState === "" || this.state.vitalState === null || this.state.vitalState === undefined) {
            errors.vitalState = "Seleccione un estado vital";
            error = true;
        } else {
            errors.vitalState = "";
        }


        if (this.state.zone === "" || this.state.zone === null || this.state.zone === undefined) {
            errors.zone = "Seleccione una Zona";
            error = true;
        } else {
            errors.zone = "";
        }

        //console.log(errors);

        if (error) {

            console.log("Error datos incorrectos");
            this.setState({
                openAlert: true,
                modalAlert: {
                    message: "No se pudo guardar el paciente",
                    color: 'warning',
                    title: "Error!"
                }
            });

        } else {
            this.updatePatient();
        }

        this.setState({ errors: errors, error: error });
    }



    updatePatient = () => {
        let data = {
            tipo_documento: this.state.typeOfDocument,
            num_documento: this.state.documentNumber,
            ape1: this.state.firstLastName,
            ape2: this.state.secondLastName,
            nombres: this.state.names,
            sexo: this.state.gender,
            fec_nacimiento: this.state.birthday,
            ocupacion: this.state.ocupation,
            direccion: {
                id_pais: this.state.country,
                id_departamento: this.state.department,
                departamento: !isNaN(this.state.department) ? this.state.departments.filter((department) => department.depcod === this.state.department)[0].depnom : '',
                ciudad: this.state.cities.filter((city) => city.ciucod === this.state.id_city)[0].ciunom,
                id_ciudad: this.state.id_city,
                direccion: this.state.address
            },
            telefono1: this.state.telephone1,
            telefono2: this.state.telephone2,
            celular: this.state.cellphone,
            correo: this.state.email,
            e_civil: this.state.civilStatus,
            id_etnia: this.state.ethnicity,
            id_raza: this.state.race,
            id_regimen: this.state.regime,
            tipo_sangre: this.state.bloodType,
            //fec_ingreso: this.state.fec_ingreso, 
            id_paciente: this.state.id_patient,
            id_historia: this.state.id_history,
            zona: this.state.zone,
            estado_vital: this.state.vitalState
        };

        console.log("DATAMODIF", data);

        fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                }
                else {
                    throw new Error("Error actualizando el paciente");
                }
            })
            .then(data => {
                console.log("QUEESESTO", data);
                this.setState({
                    openAlert: true,
                    modalAlert: {
                        message: "Paciente actualizado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    }
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    render() {
        const { classes } = this.props;
        return (
            <Container >
                <Col>
                    <Col md={12}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', margin: '0em 2em' }}>
                            {this.state.isPropsFromLocation ?
                                <div>
                                    <Tooltip
                                        title="Regresar a Base de Datos de Pacientes"
                                        style={{ padding: '2px', backgroundColor: '#55e5bb' }}
                                    >
                                        <IconButton
                                            aria-label="upload picture"
                                            component="span"
                                            className='tooltip-top'
                                            onClick={() => {
                                                history.push({
                                                    pathname: process.env.PUBLIC_URL + '/assitencial/patient-list'
                                                });
                                            }}
                                        >
                                            <ArrowBackIcon style={{ color: '#153365' }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                : null}
                            <div className='title-general-section-icon-arrow-back'>
                                <h3 style={{ marginBottom: 5, padding: '0em 0.5em' }}>Actualizar Paciente</h3>
                            </div>
                        </div>
                    </Col>

                    <Card>
                        <CardBody>
                            <div style={{ margin: '1em' }}>
                                <h5><b>DATOS BÁSICOS</b></h5>
                            </div>

                            <Row style={{ margin: '0.25em 1em' }}>
                                <Col md={3} sm={6} xs={12}>
                                    <FormControl
                                        className={'input-standar-form'}
                                        error={this.state.errors.hasOwnProperty("typeOfDocument") ? this.state.errors.typeOfDocument !== "" : false}
                                    >
                                        <InputLabel required id="demo-simple-select-label" >Tipo de Documento</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="id-simple-select"
                                            defaultValue={null}
                                            value={this.state.typeOfDocument}
                                            onChange={(event) => {
                                                console.log(event);
                                                this.handlerTypeOfDocument(event.target.value);
                                            }}
                                            error={this.state.errors.hasOwnProperty("typeOfDocument") ? this.state.errors.typeOfDocument !== "" : false}
                                        >
                                            <MenuItem className="material-form__option" key={0} value={''}>Ninguno</MenuItem>
                                            <MenuItem className="material-form__option" key={1} value={'TI'}>TI-Tarjeta de Identidad</MenuItem>
                                            <MenuItem className="material-form__option" key={2} value={'CC'}>CC-Cedula de Ciudadania</MenuItem>
                                            <MenuItem className="material-form__option" key={3} value={'PA'}>PA-Pasaporte</MenuItem>
                                            <MenuItem className="material-form__option" key={4} value={'RC'}>RC-Registro Civil</MenuItem>
                                            <MenuItem className="material-form__option" key={5} value={'CE'}>CE-Cedula de Extranjeria</MenuItem>
                                            <MenuItem className="material-form__option" key={6} value={'MS'}>MS-Menor sin Identificación</MenuItem>
                                            <MenuItem className="material-form__option" key={7} value={'AS'}>AS-Adulto sin Identificación</MenuItem>
                                            <MenuItem className="material-form__option" key={8} value={'SC'}>SC-Salvo Conducto</MenuItem>
                                            <MenuItem className="material-form__option" key={9} value={'CD'}>CD-Carnet Diplomatico</MenuItem>
                                            <MenuItem className="material-form__option" key={10} value={'CN'}>CD-Certificado de Nacido Vivo</MenuItem>
                                            <MenuItem className="material-form__option" key={11} value={'NI'}>NI-Número de Identificación Tributario NIT</MenuItem>
                                            <MenuItem className="material-form__option" key={12} value={'PE'}>PE-Permiso Especial de Permanencia</MenuItem>
                                            <MenuItem className="material-form__option" key={13} value={'PT'}>PT-Permiso por Protección Temporal</MenuItem>
                                            <MenuItem className="material-form__option" key={14} value={'SI'}>SI-Sin Identificación</MenuItem>
                                        </Select>
                                        <FormHelperText>{this.state.errors.typeOfDocument}</FormHelperText>
                                    </FormControl>
                                </Col>
                                <Col md={3} sm={6} xs={12}>
                                    <TextField
                                        required
                                        className={'input-standar-form'}
                                        id="document-number-standard-required"
                                        label="N° de documento"
                                        type="number"
                                        value={this.state.documentNumber}
                                        onChange={(e) => {
                                            this.handlerDocumentNumber(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("documentNumber") ? this.state.errors.documentNumber !== "" : false}
                                        helperText={this.state.errors.documentNumber}
                                    />
                                </Col>
                                <Col md={3} sm={6} xs={12}>
                                    <TextField
                                        required
                                        className={'input-standar-form'}
                                        id="first-name-standard-required"
                                        label="Nombres"
                                        type="text"
                                        value={this.state.names}
                                        onChange={(e) => {
                                            this.handlerNames(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("names") ? this.state.errors.names !== "" : false}
                                        helperText={this.state.errors.names}
                                    />
                                </Col>
                                <Col md={3} sm={6} xs={12}>
                                    <TextField
                                        required
                                        className={'input-standar-form'}
                                        id="first-last-name-standard-required"
                                        label="Primer apellido"
                                        type="text"
                                        value={this.state.firstLastName}
                                        onChange={(e) => {
                                            this.handlerFirstLastName(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("firstLastName") ? this.state.errors.firstLastName !== "" : false}
                                        helperText={this.state.errors.firstLastName}
                                    />
                                </Col>
                            </Row>
                            <Row style={{ margin: '0.25em 1em' }}>
                                <Col md={3} sm={6} xs={12}>
                                    <TextField
                                        required
                                        className={'input-standar-form'}
                                        id="second-last-name-standard-required"
                                        label="Segundo apellido"
                                        type="text"
                                        value={this.state.secondLastName}
                                        onChange={(e) => {
                                            this.handlerSecondLastName(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("secondLastName") ? this.state.errors.secondLastName !== "" : false}
                                        helperText={this.state.errors.secondLastName}
                                    />
                                </Col>
                                <Col md={3} sm={6} xs={12}>
                                    <FormControl
                                        className={'input-standar-form'}
                                        error={this.state.errors.hasOwnProperty("gender") ? this.state.errors.gender !== "" : false}
                                    >
                                        <InputLabel required id="demo-simple-select-label">Genero</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="id-simple-select"
                                            defaultValue={null}
                                            value={this.state.gender}
                                            onChange={(event) => {
                                                this.handlerGender(event.target.value);
                                            }}
                                            error={this.state.errors.hasOwnProperty("gender") ? this.state.errors.gender !== "" : false}
                                            helperText={this.state.errors.gender}
                                        >
                                            <MenuItem key={0} value={''}>Ninguno</MenuItem>
                                            <MenuItem key={1} value={'Masculino'}>Masculino</MenuItem>
                                            <MenuItem key={2} value={'Femenino'}>Femenino</MenuItem>
                                            <MenuItem key={3} value={'Binario'}>Binario</MenuItem>
                                        </Select>
                                        <FormHelperText>{this.state.errors.gender}</FormHelperText>
                                    </FormControl>
                                </Col>
                                <Col md={3} sm={6} xs={12}>
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <KeyboardDatePicker
                                            disableFuture
                                            label="Fecha de Nacimiento"
                                            value={this.state.birthday}
                                            onChange={(date) => {
                                                if (date !== null) {
                                                    if (date._isValid) {
                                                        this.handlerBirthDate(new Date(date));
                                                    } else {
                                                        this.handlerBirthDate(new Date(date._i));
                                                    }
                                                }
                                            }}
                                            animateYearScrolling
                                            format="DD/MM/YYYY"
                                            className={'input-standar-form'}
                                            error={this.state.errors.hasOwnProperty("birthday") ? this.state.errors.birthday !== "" : false}
                                            helperText={this.state.errors.birthday}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Col>
                                <Col md={3} sm={6} xs={12}>
                                    <TextField
                                        className={'input-standar-form'}
                                        id="first-telephone-standard-required"
                                        label="Teléfono 1"
                                        type="text"
                                        value={this.state.telephone1}
                                        onChange={(e) => {
                                            this.handlerTelephone1(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("telephone1") ? this.state.errors.telephone1 !== "" : false}
                                        helperText={this.state.errors.telephone1}
                                    />
                                    {/* <TextField
                                        className={'input-standar-form'}
                                        id="second-telephone-standard-required"
                                        label="Teléfono 2"
                                        type="text"
                                        value={this.state.telephone2}
                                        onChange={(e) => {
                                            this.handlerTelephone2(e.target.value);
                                        }}
                                    /> */}
                                </Col>
                            </Row>
                            <Row style={{ margin: '0.25em 1em' }}>
                                <Col md={3} sm={6} xs={12}>
                                    <TextField
                                        required
                                        className={'input-standar-form'}
                                        id="cellphone-standard-required"
                                        label="Celular"
                                        type="text"
                                        value={this.state.cellphone}
                                        onChange={(e) => {
                                            this.handlerCellphone(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("cellphone") ? this.state.errors.cellphone !== "" : false}
                                        helperText={this.state.errors.cellphone}
                                    />
                                </Col>
                                <Col md={3} sm={6} xs={12}>
                                    <TextField
                                        required
                                        className={'input-standar-form'}
                                        id="email-standard-required"
                                        label="Correo electrónico"
                                        type="email"
                                        value={this.state.email}
                                        onChange={(e) => {
                                            this.handlerEmail(e.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("email") ? this.state.errors.email !== "" : false}
                                        helperText={this.state.errors.email}
                                    />
                                </Col>
                                <Col md={3} sm={6} xs={12}>
                                    <FormControl
                                        className={'input-standar-form'}
                                        error={this.state.errors.hasOwnProperty("regime") ? this.state.errors.regime !== "" : false}
                                    >
                                        <InputLabel id="regime-status-select-label">Regimen</InputLabel>
                                        <Select
                                            labelId="regime-select-label"
                                            id="id-simple-select"
                                            defaultValue={null}
                                            value={this.state.regime}
                                            onChange={(event) => {
                                                this.handlerRegime(event.target.value);
                                            }}
                                            error={this.state.errors.hasOwnProperty("regime") ? this.state.errors.regime !== "" : false}
                                        >
                                            <MenuItem key={0} value={''}>Ninguna</MenuItem>
                                            {this.state.regimes.map((regime) => {
                                                return <MenuItem key={regime.id_regimen} value={regime.id_regimen}>{regime.regimen}</MenuItem>
                                            })}
                                        </Select>
                                        <FormHelperText>{this.state.errors.regime}</FormHelperText>
                                    </FormControl>
                                </Col>
                                <Col md={3} sm={6} xs={12}>
                                    <TextField
                                        id="ocupation-standard-required"
                                        label="Ocupacion"
                                        type="text"
                                        className={'input-standar-form'}
                                        //style={{ width: 200, marginLeft: 20 }}
                                        value={this.state.ocupation}
                                        onChange={(e) => {
                                            this.setState({ ocupation: e.target.value });
                                        }}
                                        error={this.state.errors.hasOwnProperty("ocupation") ? this.state.errors.ocupation !== "" : false}
                                        helperText={this.state.errors.ocupation}
                                    />

                                </Col>
                            </Row>


                            <div style={{ margin: '1em 1em' }}>
                                <h5><b>DATOS DE UBICACIÓN</b></h5>
                            </div>
                            <div>

                                <Row style={{ margin: '0.25em 1em' }}>
                                    <Col md={3} sm={6} xs={12}>
                                        <FormControl
                                            className={'input-standar-form'}
                                            error={this.state.errors.hasOwnProperty("country") ? this.state.errors.country !== "" : false}
                                        >
                                            <InputLabel id="country-status-select-label">País</InputLabel>
                                            <Select
                                                labelId="country-select-label"
                                                id="id-simple-select"
                                                defaultValue={null}
                                                value={this.state.country}
                                                onChange={(event) => {
                                                    this.handlerCountry(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("country") ? this.state.errors.country !== "" : false}
                                            >
                                                {this.state.countries.map((country) => {
                                                    return <MenuItem className="material-form__option" key={country.paicod} value={country.paicod}>{country.painom}</MenuItem>
                                                })}
                                            </Select>
                                            <FormHelperText>{this.state.errors.country}</FormHelperText>
                                        </FormControl>
                                    </Col>
                                    <Col md={3} sm={6} xs={12}>
                                        {this.state.country === '00038' ?
                                            <Fragment>
                                                <FormControl
                                                    className={'input-standar-form'}
                                                    error={this.state.errors.hasOwnProperty("department") ? this.state.errors.department !== "" : false}
                                                >
                                                    <InputLabel id="department-status-select-label">Departamento</InputLabel>
                                                    <Select
                                                        labelId="department-select-label"
                                                        id="id-simple-select"
                                                        defaultValue={null}
                                                        value={this.state.department}
                                                        onChange={(event) => {
                                                            this.handlerDepartment(event.target.value);
                                                        }}
                                                        error={this.state.errors.hasOwnProperty("department") ? this.state.errors.department !== "" : false}
                                                    >
                                                        {this.state.departments.map((department) => {
                                                            return <MenuItem key={department.id} value={department.depcod}>{department.depnom}</MenuItem>
                                                        })}
                                                    </Select>
                                                    <FormHelperText>{this.state.errors.department}</FormHelperText>
                                                </FormControl>
                                            </Fragment>
                                            : <Fragment>
                                                < TextField
                                                    required
                                                    id="state-standard-required"
                                                    label="Departamento o Estado"
                                                    type="text"
                                                    className="material-form__field"
                                                    value={this.state.department}
                                                    onChange={(e) => {
                                                        this.handlerDepartment(e.target.value);
                                                    }}
                                                    error={this.state.errors.hasOwnProperty("department") ? this.state.errors.department !== "" : false}
                                                    helperText={this.state.errors.department}
                                                />
                                            </Fragment>}
                                    </Col>
                                    <Col md={3} sm={6} xs={12}>
                                        {this.state.country === '00038' ?
                                            <Fragment>
                                                <FormControl
                                                    className={'input-standar-form'}
                                                    error={this.state.errors.hasOwnProperty("city") ? this.state.errors.city !== "" : false}
                                                >
                                                    <InputLabel id="city-status-select-label">Ciudad</InputLabel>
                                                    <Select
                                                        labelId="city-select-label"
                                                        id="id-simple-select"
                                                        defaultValue={null}
                                                        value={this.state.city}
                                                        onChange={(event) => {
                                                            this.handlerCity(event.target.value);
                                                        }}
                                                        error={this.state.errors.hasOwnProperty("city") ? this.state.errors.city !== "" : false}
                                                    >
                                                        <MenuItem key={0} value={this.state.city}>{this.state.city}</MenuItem>
                                                        {this.state.cities.map((city) => {
                                                            return <MenuItem key={city.id} value={city.ciucod}>{city.ciunom}</MenuItem>
                                                        })}

                                                    </Select>
                                                    <FormHelperText>{this.state.errors.city}</FormHelperText>
                                                </FormControl>
                                            </Fragment>
                                            : <Fragment>
                                                < TextField
                                                    required
                                                    id="city-standard-required"
                                                    label="Ciudad"
                                                    type="text"
                                                    className="material-form__field"
                                                    value={this.state.city}
                                                    onChange={(e) => {
                                                        this.handlerCity(e.target.value);
                                                    }}
                                                    error={this.state.errors.hasOwnProperty("city") ? this.state.errors.city !== "" : false}
                                                    helperText={this.state.errors.city}
                                                />
                                            </Fragment>}
                                    </Col>
                                    <Col md={3} sm={6} xs={12}>
                                        <TextField
                                            required
                                            className={'input-standar-form'}
                                            id="address-standard-required"
                                            label="Dirección"
                                            type="text"
                                            value={this.state.address}
                                            onChange={(e) => {
                                                this.handlerAddress(e.target.value);
                                            }}
                                            error={this.state.errors.hasOwnProperty("address") ? this.state.errors.address !== "" : false}
                                            helperText={this.state.errors.address}
                                        />

                                    </Col>
                                </Row>

                                <Row style={{ margin: '0.25em 1em' }}>
                                    <Col md={3} sm={6} xs={12}>
                                        <TextField
                                            className={'input-standar-form'}
                                            label="Zona"
                                            id="id-zone-select"
                                            select
                                            value={this.state.zone}
                                            onChange={(event) => {
                                                this.handlerZone(event.target.value);
                                                console.log(event.target);
                                            }}
                                            error={this.state.errors.hasOwnProperty("zone") ? this.state.errors.zone !== "" : false}
                                            helperText={this.state.errors.zone}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                        >
                                            <MenuItem className="material-form__option" key={1} value={'U'}>URBANA</MenuItem>
                                            <MenuItem className="material-form__option" key={2} value={'R'}>RURAL</MenuItem>
                                        </TextField>
                                    </Col>
                                </Row>

                            </div>

                            <React.Fragment>
                                <div style={{ margin: '1em 1em' }}>
                                    <h5><b>DATOS ADICIONALES</b></h5>
                                </div>
                                <Row style={{ margin: '0.25em 1em' }}>
                                    <Col md={3} sm={6} xs={12}>
                                        <FormControl
                                            className={'input-standar-form'}
                                            error={this.state.errors.hasOwnProperty("civilStatus") ? this.state.errors.civilStatus !== "" : false}
                                        >
                                            <InputLabel id="civil-status-select-label">Estado civil</InputLabel>
                                            <Select
                                                labelId="civil-status-select-label"
                                                id="id-simple-select"
                                                defaultValue={null}
                                                value={this.state.civilStatus}
                                                onChange={(event) => {
                                                    this.handlerCivilStatus(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("civilStatus") ? this.state.errors.civilStatus !== "" : false}
                                            >
                                                <MenuItem key={0} value={''}>Ninguno</MenuItem>
                                                <MenuItem key={1} value={'Soltero'}>Soltero</MenuItem>
                                                <MenuItem key={2} value={'Casado'}>Casado</MenuItem>
                                                <MenuItem key={2} value={'Divorciado'}>Divorciado</MenuItem>
                                                <MenuItem key={2} value={'Viudo'}>Viudo</MenuItem>
                                                <MenuItem key={2} value={'Unión Libre'}>Unión Libre</MenuItem>
                                            </Select>
                                            <FormHelperText>{this.state.errors.civilStatus}</FormHelperText>
                                        </FormControl>
                                    </Col>
                                    <Col md={3} sm={6} xs={12}>
                                        <FormControl
                                            className={'input-standar-form'}
                                            error={this.state.errors.hasOwnProperty("race") ? this.state.errors.race !== "" : false}
                                        >
                                            <InputLabel id="races-status-select-label">Raza</InputLabel>
                                            <Select
                                                labelId="races-select-label"
                                                id="id-simple-select"
                                                defaultValue={null}
                                                value={this.state.race}
                                                onChange={(event) => {
                                                    this.handlerRace(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("race") ? this.state.errors.race !== "" : false}
                                            >
                                                <MenuItem key={0} value={''}>Ninguna</MenuItem>
                                                {this.state.races.map((race) => {
                                                    return <MenuItem key={race.id_raza} value={race.id_raza}>{race.raza}</MenuItem>
                                                })}
                                            </Select>
                                            <FormHelperText>{this.state.errors.race}</FormHelperText>
                                        </FormControl>
                                    </Col>
                                    <Col md={3} sm={6} xs={12}>
                                        <FormControl
                                            className={'input-standar-form'}
                                            error={this.state.errors.hasOwnProperty("ethnicity") ? this.state.errors.ethnicity !== "" : false}
                                        >
                                            <InputLabel id="ethnicity-status-select-label">Etnia</InputLabel>
                                            <Select
                                                labelId="ethnicity-select-label"
                                                id="id-simple-select"
                                                defaultValue={null}
                                                value={this.state.ethnicity}
                                                onChange={(event) => {
                                                    this.handlerEthnicity(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("ethnicity") ? this.state.errors.ethnicity !== "" : false}
                                            >
                                                <MenuItem key={0} value={''}>Ninguna</MenuItem>
                                                {this.state.ethnicities.map((ethnicity) => {
                                                    return <MenuItem key={ethnicity.id_etnia} value={ethnicity.id_etnia}>{ethnicity.etnia}</MenuItem>
                                                })}
                                            </Select>
                                            <FormHelperText>{this.state.errors.ethnicity}</FormHelperText>
                                        </FormControl>
                                    </Col>
                                    <Col md={3} sm={6} xs={12}>
                                        <FormControl
                                            className={'input-standar-form'}
                                            error={this.state.errors.hasOwnProperty("bloodType") ? this.state.errors.bloodType !== "" : false}
                                        >
                                            <InputLabel id="blood-type-select-label">tipo de sangre</InputLabel>
                                            <Select
                                                labelId="blood-type-select-label"
                                                id="id-simple-select"
                                                defaultValue={null}
                                                value={this.state.bloodType}
                                                onChange={(event) => {
                                                    this.handlerBloodType(event.target.value);
                                                }}
                                                error={this.state.errors.hasOwnProperty("bloodType") ? this.state.errors.bloodType !== "" : false}
                                            >
                                                <MenuItem key={0} value={'A+'}>A+</MenuItem>
                                                <MenuItem key={0} value={'B+'}>B+</MenuItem>
                                                <MenuItem key={0} value={'O+'}>O+</MenuItem>
                                                <MenuItem key={0} value={'A-'}>A-</MenuItem>
                                                <MenuItem key={0} value={'B-'}>B-</MenuItem>
                                                <MenuItem key={0} value={'O-'}>O-</MenuItem>
                                                <MenuItem key={0} value={'AB+'}>AB+</MenuItem>
                                                <MenuItem key={0} value={'AB-'}>AB-</MenuItem>
                                                <MenuItem key={0} value={'SIN DEFINIR'}>SIN DEFINIR</MenuItem>


                                            </Select>
                                            <FormHelperText>{this.state.errors.bloodType}</FormHelperText>
                                        </FormControl>
                                    </Col>
                                </Row>
                                <Row style={{ margin: '0.25em 1em' }}>
                                    <Col md={3} sm={6} xs={12}>
                                        <FormControl
                                            className={'input-standar-form'}
                                            error={this.state.errors.hasOwnProperty("vitalState") ? this.state.errors.vitalState !== "" : false}
                                        >
                                            <InputLabel id="blood-type-select-label">Estado vital</InputLabel>
                                            <Select
                                                labelId="blood-type-select-label"
                                                id="id-simple-select"
                                                defaultValue={null}
                                                value={this.state.vitalState}
                                                onChange={(event) => {
                                                    this.handlerVitalState(event.target.value);
                                                    console.log("ESTADOVITAL", this.state.vitalState)
                                                }}
                                                error={this.state.errors.hasOwnProperty("vitalState") ? this.state.errors.vitalState !== "" : false}
                                            >
                                                <MenuItem key={0} value={'VIVO'}>VIVO</MenuItem>
                                                <MenuItem key={1} value={'MUERTO'}>MUERTO</MenuItem>
                                                <MenuItem key={2} value={'DESAPARECIDO'}>DESAPARECIDO</MenuItem>
                                            </Select>
                                            <FormHelperText>{this.state.errors.vitalState}</FormHelperText>
                                        </FormControl>
                                    </Col>
                                </Row>

                            </React.Fragment>

                            <Row style={{ margin: '0.25em 1em' }}>
                                <Col md={3} sm={6} xs={12}>
                                    <Button
                                        className={classes.date}
                                        style={{ marginTop: 20 }}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.validateData();
                                            //this.updatePatient();

                                        }}
                                    >
                                        Actualizar Paciente
                                    </Button>
                                </Col>
                            </Row>

                            {this.state.openAlert && this.state.modalAlert.title === "Error!" ?
                                <ModalMessage
                                    color={this.state.modalAlert.color}
                                    title={this.state.modalAlert.title}
                                    message={this.state.modalAlert.message}
                                    modal={this.state.openAlert}
                                    toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                                    onOk={() => {
                                        this.setState({ openAlert: !this.state.openAlert })
                                    }}
                                /> :
                                <ModalMessage
                                    color={this.state.modalAlert.color}
                                    title={this.state.modalAlert.title}
                                    message={this.state.modalAlert.message}
                                    modal={this.state.openAlert}
                                    toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                                    onOk={() => {
                                        this.state.isPropsFromLocation ?
                                            history.push({
                                                pathname: process.env.PUBLIC_URL + '/assitencial/patient-list'
                                            })
                                            :
                                            this.setState({ openAlert: !this.state.openAlert })
                                        this.props.setEditPatient(false)
                                    }}
                                />

                            }
                            <Modal
                                open={this.state.openMap}
                                onClose={e => {
                                    this.setState({ openMap: !this.state.openMap });
                                }}
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                            //style={{zIndex: 1000 }}
                            >
                                <div style={{
                                    position: 'absolute',
                                    backgroundColor: 'white',
                                    width: '80%',
                                    height: '80%',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    padding: 20
                                }}
                                >
                                    <MapAddressSearch />
                                </div>
                            </Modal>
                        </CardBody>
                    </Card>
                </Col>
            </Container>
        );
    }
}

export default withStyles(styles, { withTheme: true })(UpdatePatient);